export default __webpack_public_path__ + "static/media/coils.7709ae78.PNG";